import React from 'react';
import PropTypes from 'prop-types';

import Pagination from '@andes/pagination';

import HeaderComponent from '../../../components/Header';
import BlogEntryContainerDeskopComponent from '../../../components/BlogEntryContainerDesktop';
import BlogEntryContainerMobileComponent from '../../../components/BlogEntryContainerMobile';

const Blog = (props) => {
  const { blogData, device, jsDisabled, supportWebP } = props;

  const {
    site_id: siteId,
    title,
    description,
    blogs,
    page,
    total_pages: totalPages,
  } = blogData;

  const BlogEntryContainer =
    device === 'mobile'
      ? BlogEntryContainerMobileComponent
      : BlogEntryContainerDeskopComponent;

  const formatUrl = (href, currentPage) => {
    if (currentPage === 0 || currentPage - 1 === totalPages) {
      return undefined;
    }

    return href.replace('$page', currentPage);
  };

  return (
    <div>
      <HeaderComponent
        siteId={siteId}
        title={title}
        description={description}
        device={device}
      />

      <BlogEntryContainer
        blogEntries={blogs}
        jsDisabled={jsDisabled}
        supportWebP={supportWebP}
      />

      <Pagination
        pageSelected={page}
        pageQuantity={totalPages}
        href="$page"
        formatUrl={formatUrl}
      />
    </div>
  );
};

Blog.propTypes = {
  device: PropTypes.string.isRequired,
  jsDisabled: PropTypes.bool.isRequired,
  supportWebP: PropTypes.bool.isRequired,
  blogData: PropTypes.shape({
    site_id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    page: PropTypes.number.isRequired,
    total_pages: PropTypes.number.isRequired,
    blogs: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        image: PropTypes.shape({
          url: PropTypes.string.isRequired,
          alt: PropTypes.string.isRequired,
        }).isRequired,
        description: PropTypes.string.isRequired,
        tags: PropTypes.arrayOf(PropTypes.string),
        tags_metadata: PropTypes.arrayOf(
          PropTypes.shape({
            url: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
          }),
        ),
      }),
    ),
  }).isRequired,
};

Blog.defaultProps = {
  pageNumber: 1,
};

export default Blog;
